import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

// Moved from src/features/selfServeCheckout/selfServeCheckoutReducer.js.
//
// The slice's `name`/state key stays "selfServeCheckout" - NOT renamed to
// "selfServeUsersFeature" to match _features/company's "companyFeature"
// convention, since renaming would break the redux-persist entry and the
// REHYDRATE payload key below for existing persisted sessions.
//
// `.bundles` is now fully dead (2026-07-27) - it existed solely so the old
// `pages/SelfserveCheckout/index.js` could mirror a query result into this
// slice and read it straight back out via `useSelector`, confirmed via
// grep to have no other reader anywhere in the app. That page has since
// migrated into `_features/selfServeCheckout`, which reads its bundles
// query result directly instead. Not removed here (a different feature's
// field) - flagged in docs/known-issues.md.

const DEFAULT_SORT = "-createdAt";

const initialState = {
  bundles: [],
  selfserveusers: [],
  configurations: [],
  // Dedicated selected filters (was incorrectly shared with customerSlice)
  selectedSelfServeUserFilters: {
    sort: DEFAULT_SORT,
  },
};

const selfServeCheckoutSlice = createSlice({
  name: "selfServeCheckout",
  initialState,
  reducers: {
    setSelfServeCheckoutBundles(state, action) {
      state.bundles = action.payload;
    },
    setSelfServeCheckoutUsers(state, action) {
      state.selfserveusers = action.payload;
    },
    setSelfServeCheckoutConfig(state, action) {
      state.configurations = action.payload;
    },
    // ADR-F005: replace
    updateSelectedSelfServeUserFilters(state, action) {
      state.selectedSelfServeUserFilters = action.payload;
    },
    resetSelectedSelfServeUserFilters(state) {
      state.selectedSelfServeUserFilters = {
        sort: DEFAULT_SORT,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.selfServeCheckout) {
        const persistedData = action.payload.selfServeCheckout;
        const persistedFilters = persistedData.selectedSelfServeUserFilters;

        return {
          ...state,
          ...persistedData,
          selectedSelfServeUserFilters: {
            ...(persistedFilters && typeof persistedFilters === "object"
              ? persistedFilters
              : {}),
            sort: persistedFilters?.sort || DEFAULT_SORT,
          },
        };
      }
      return state;
    });
  },
});

export const {
  setSelfServeCheckoutBundles,
  setSelfServeCheckoutConfig,
  setSelfServeCheckoutUsers,
  updateSelectedSelfServeUserFilters,
  resetSelectedSelfServeUserFilters,
} = selfServeCheckoutSlice.actions;

export default selfServeCheckoutSlice.reducer;
